// extracted by mini-css-extract-plugin
export default {"header":"_2tsc--w2","footer":"k-5KT7MW"};